import { render } from "./ExpiredAssetsSettings.vue?vue&type=template&id=463f2b35&scoped=true&ts=true"
import script from "./ExpiredAssetsSettings.vue?vue&type=script&lang=ts"
export * from "./ExpiredAssetsSettings.vue?vue&type=script&lang=ts"

import "./ExpiredAssetsSettings.vue?vue&type=style&index=0&id=463f2b35&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463f2b35"]])

export default __exports__